import React from 'react'
import SellerstepForm from './SellerstepFormMain/SellerstepForm'

const Vendor_form = () => {
    return (
        <>
            <section className='Vendor_form_sec mt-5'>
                <div className='container'>
                    <div className='background-card'>
                        <img className='curve-img' src={process.env.PUBLIC_URL + '/assets/images/about-us/banner/layer.png'} />

                        <div className='row'>
                            <div className='col-lg-10 mx-auto'>
                                <SellerstepForm />
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Vendor_form